@for (
  widget of widgets
  | filter: outletFilter:name
  | filter: permissionFilter:(permissions$ | async)
  | sort: 'priority'
  ; track
  widget) {
  <ng-container
    *ngComponentOutlet="
      widget.component;
      injector: injector
        | widgetOutletInjector: widget.providers ?? []:contextProviders
    "
  ></ng-container>
}
